var map = {
	"./calendar/calendar.module": [
		"../../../../../src/app/main/content/apps/calendar/calendar.module.ts",
		"calendar.module",
		"common"
	],
	"./contacts/contacts.module": [
		"../../../../../src/app/main/content/apps/contacts/contacts.module.ts",
		"common",
		"contacts.module"
	],
	"./e-commerce/e-commerce.module": [
		"../../../../../src/app/main/content/apps/e-commerce/e-commerce.module.ts",
		"e-commerce.module",
		"common"
	],
	"./main/content/apps/apps.module": [
		"../../../../../src/app/main/content/apps/apps.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// I:/1.speKwo/New Spekwo Revamp/admindash/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main